import {
    ADMIN_CONFIRM_EMAIL_PATH,
    ADMIN_CONFIRM_INVITATION_PATH,
    ADMIN_FORGOT_PASSWORD_PATH,
    ADMIN_LOGIN_PATH,
    ADMIN_RESET_PASSWORD_PATH,
    ADMIN_SIGNUP_PATH,
} from './paths.ts';

export default [
    {
        handle: {
            title: ['auth:loginPage.documentTitle'],
        },
        path: ADMIN_LOGIN_PATH,
        lazy: async () => ({ Component: (await import('./pages/LoginPage.tsx')).default }),
    },
    {
        handle: {
            title: ['auth:signupPage.documentTitle'],
        },
        path: ADMIN_SIGNUP_PATH,
        lazy: async () => ({ Component: (await import('./pages/SignupPage.tsx')).default }),
    },
    {
        handle: {
            title: ['auth:confirmEmailPage.documentTitle'],
        },
        path: ADMIN_CONFIRM_EMAIL_PATH,
        lazy: async () => ({ Component: (await import('./pages/ConfirmEmailPage.tsx')).default }),
    },
    {
        handle: {
            title: ['auth:confirmInvitationPage.documentTitle'],
        },
        path: ADMIN_CONFIRM_INVITATION_PATH,
        lazy: async () => ({ Component: (await import('./pages/ConfirmInvitationPage.tsx')).default }),
    },
    {
        handle: {
            title: ['auth:forgotPasswordPage.documentTitle'],
        },
        path: ADMIN_FORGOT_PASSWORD_PATH,
        lazy: async () => ({ Component: (await import('./pages/ForgotPasswordPage.tsx')).default }),
    },
    {
        handle: {
            title: ['auth:resetPasswordPage.documentTitle'],
        },
        path: ADMIN_RESET_PASSWORD_PATH,
        lazy: async () => ({ Component: (await import('./pages/ResetPasswordPage.tsx')).default }),
    },
];
